import React, { useState } from "react";
import Header from "../components/Header";
import HeroSection from "../components/HeroSection";
import ServicesSection from "../components/ServicesSection";
import CalculatorSection from "../components/CalculatorSection";
import TestimonialsSection from "../components/TestimonialsSection";
import FAQSection from "../components/FAQSection";
import ContactSection from "../components/ContactSection";
import Footer from "../components/Footer";
import WatermarkRemover from "../components/WatermarkRemover";

const HomePage = () => {
  return (
    <div className="min-h-screen bg-white">
      <WatermarkRemover />
      <Header />
      <HeroSection />
      <ServicesSection />
      <CalculatorSection />
      <TestimonialsSection />
      <FAQSection />
      <ContactSection />
      <Footer />
    </div>
  );
};

export default HomePage;